import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass der Aktivitäts-Feed erst lädt, wenn der Tab-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'project-timeline',
  name: 'Projekt-Verlauf',
  description:
    'Chronologischer Aktivitäts-Feed eines Projekts — Status, Versionen, Kommentare, Zuordnungen, Audit.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ],
  enabledByDefault: true,
};

const TimelineTab = lazy(() => import('./TimelineTab').then((m) => ({ default: m.TimelineTab })));

export const projectTimelineSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'project-timeline',
        order: 30,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId
        render: TimelineTab,
      },
    ],
  },
};
